export const RECEIVER_CHECKED = 'RECEIVER_CHECKED';
export const LOGGER_CHECKED = 'LOGGER_CHECKED';
export const ALERT_CHECKED = 'ALERT_CHECKED';
export const BATTERY_CHECKED = 'BATTERY_CHECKED';

export const TOKYO_CENTOR_LAT_LNG = {
  lat: 35.700482,
  lng: 139.627949,
};

export const DEFAULT_ZOOM = 11;

export const GSP_PERIOD_TIMES = {
  NO_JUDGMENT: 'NO_JUDGMENT',
  TIME_3_HOURS: '3_HOURS',
  TIME_6_HOURS: '6_HOURS',
  TIME_12_HOURS: '12_HOURS',
  TIME_1_DAY: '1_DAY',
  TIME_2_DAYS: '2_DAYS',
  TIME_3_DAYS: '3_DAYS',
  CUSTOM: 'CUSTOM',
};

export const DEVICE_TYPE = {
  RECEIVER: 'RECEIVER',
  LOGGER: 'LOGGER',
};

export const MZ_DATA = {
  // eventFlag
  E4: {
    OFF: 0, // フラグOFF
    ON: 1, // フラグON"
  },
  // alarm Flag
  E5_VALUE: {
    NONE: 0, // なし
  },
  E5: {
    0: 'なし',
    1: '閾値逸脱',
    2: '警報',
    3: '逸脱警報成立',
  },
  // sensor Error
  C2_VALUE: {
    OK: 0, // 全てOK
  },
  C2: {
    0: '全てOK',
    1: '1chのみ異常',
    2: '2chのみ異常',
    3: '3chのみ異常',
    4: '1,2chが異常',
    5: '1,3chが異常',
    6: '2,3chが異常',
    7: '全て異常',
  },
  // memory Error
  C3_VALUE: {
    OK: 0, // 全てOK
  },
  C3: {
    0: '全てOK',
    1: 'プライマリ/セカンダリどちらか異常あり',
  },
  // other Device Error
  C4_VALUE: {
    NO: 0,
    YES: 1,
  },
  C4: {
    0: 'なし',
    1: 'あり',
  },
  // Receiver error
  O1_VALUE: {
    NONE: 0, // なし
  },
  O1: {
    0: 'なし',
    1: '受信器位置情報の異常',
    2: 'データベース異常',
    3: '設定ファイル異常',
    4: '時計情報異常',
    5: 'その他',
  },
  // power Supply Type
  O3_VALUE: {
    EXTERNAL_POWER_SUPPLY: 0,
    BUILT_IN_RECHARGEABLE_BATTERY_PW: 1,
    AT_THE_START_OF_SHUTDOWN: 2,
    BOTH_POWER_IS_RESTORED: 3,
    BUILT_IN_RECHARGEABLE_BATTERY_NOT_CONNECTED: 4,
  },
  O3: {
    0: '外部電源供給(ON)',
    1: '内蔵充電池駆動(充電池：赤字)',
    2: 'シャットダウン開始時(停止：赤字)',
    3: '電源復帰時(警報メール送信と連動用。次回送信時は「0」or「1」)(ON)',
    4: '内蔵充電池未接続(充電池なし)',
  },
  O3_TEXT: {
    0: '正常',
    1: '充電池',
    2: '停止',
    3: '正常',
    4: '充電池無し',
  },
  O3_TEXT_V2: {
    0: 'ON',
    1: '停電',
    2: '停止',
    3: 'ON',
    4: '充電池なし',
  },
  // Battery level
  C1_VALUE: {
    REMAINING_AMOUNT_MINI: 0,
    ALARM_ISSUE: 1,
    UNKNOWN_2: 2,
    UNKNOWN_3: 3,
  },
  C1: {
    0: '残量mini',
    1: '警報発報',
    2: '不明(2)',
    3: '不明(3)',
  },
  // Sensor type
  A2_VALUE: {
    BUILT_IN_THERMISTOR: 0,
    THERMISTOR: 1,
    TEMPERATURE_HUMIDITY: 2,
    RTD: 3,
    VOLTAGE: 4,
    PULSE: 5,
    K_THERMOCOUPLE: 6,
    T_THERMOCOUPLE: 7,
  },
  A2: {
    0: '内蔵サーミスタ',
    1: '外付けサーミスタ',
    2: '温湿度',
    3: '測温抵抗体',
    4: '電圧',
    5: 'パルス',
    6: 'K熱電対',
    7: 'T熱電対',
  },
};
